export default {
  listaEventTypes: [],
  eventType: {
    nome: '',
    ativo: true,
  },
}
